const ruleSet = {
  h_Object: {
    valueNotEquals: 'default'
  },
  h_NetAcquisitionValue: {
    required: true,
    numberSeperator: true,
    minSeperator: 500
  },
  h_LeasingTerm: {
    valueNotEquals: 'default'
  },
  h_Company: {
    required: true,
  },
  h_PostalCode: {
    required: true,
    postalCode: true
  },
  h_AnnualRevenue: {
    valueNotEquals: 'default'
  },
  DisclaimerFoerdergutschein: {
    isChecked: true
  }
}

// jQuery validate object
let calculatorForm

async function init () {
  if ($('#calculator').length > 0) {
    await import(/* webpackChunkName: "jq-validation-additional-methods" */ 'jquery-validation/dist/additional-methods.js')
    initValidation()
  }
}

function initValidation () {
  let calculatorDom = $('#calculator-form')

  $.validator.addMethod('valueNotEquals', function (value, element, arg) {
    return arg !== value
  }, window.formErrors.dropdown)
  $.validator.addMethod('isChecked', function (value, element, arg) {
    return element.checked === arg
  }, window.formErrors.default)

  $.validator.addMethod('postalCode', function (value, element, param) {
    return (new RegExp(window.fgsCalculatorValidationRules.postalCodeRegex)).test(value)
  })

  $.validator.addMethod('minSeperator', function (value, element, arg) {
    return parseFloat(value.replace(/\./g, '')) >= arg
  })

  $.validator.addMethod('numberSeperator', function (value, element, param) {
    return /^([0-9]|\.|\,)*$/.test(value)
  })

  calculatorForm = calculatorDom.validate({
    ignore: [],
    focusInvalid: false,
    debug: false,
    success: 'valid',
    rules: ruleSet,
    messages: {
      h_Object: {
        valueNotEquals: window.formErrors.dropdown
      },
      h_NetAcquisitionValue: {
        required: window.formErrors.default,
        numberSeperator: window.formErrors.inputNumber,
        minSeperator: window.formErrors.inputMinValue500
      },
      h_LeasingTerm: {
        valueNotEquals: window.formErrors.dropdown
      },
      h_Company: {
        required: window.formErrors.default,
      },
      h_PostalCode: {
        required: window.formErrors.default,
        postalCode: window.formErrors.inputZip
      },
      h_AnnualRevenue: {
        valueNotEquals: window.formErrors.dropdown
      },
      DisclaimerFoerdergutschein: {
        isChecked: window.formErrors.checkRequired
      }
    },
    onkeyup: function (element, event) {
      $(element).valid()
    },
    onfocusout: function (element) {
      $(element).valid()
    },
    onclick: function (element) {
      if ($(element).hasClass('formRow--checkbox')) {
        $(element).valid()
      }
    },
    errorPlacement: function (error, $element) {
      error.insertAfter($element)
    },
    submitHandler: function (form) {
      localStorage.eloquaForm = JSON.stringify(getFormData(form))
      form.submit()
    }
  })

  calculatorDom.find('.formRow--dropdown-select').each((index, element) => {
    let selectItem = element

    $(selectItem)
      .siblings('.formRow--dropdown-list')
      .find('.formRow--dropdown-list-item')
      .on('click', () => {
        calculatorForm.element(selectItem)
      })
  })
}

function getFormData (form) {
  let unindexed_array = $(form).serializeArray()
  let indexed_array = {}

  $.map(unindexed_array, function (n, i) {
    indexed_array[n['name']] = n['value']
  })

  return indexed_array
}

export default {
  init
}
